import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import "./style.css";
import { useEffect, useState } from "react";

const AlarmTable = ({ tableTD, tableData, bedData, userInfo }) => {
	const [filteredAlarm, setFilteredAlarm] = useState([]);
	const [suiteNames, setSuiteNames] = useState([]);

	const [hour, setHour] = useState("");
	const [suiteName, setSuiteName] = useState("");

	useEffect(() => {
		// Tüm alarm verilerini göster (bedData'da olmayan V46 saatler dahil)
		setFilteredAlarm(tableData || []);

		const names = (tableData || []).map((data) => {
			// Önce bedData'dan süit adını bul, yoksa alarm verisindeki suiteName'i kullan
			const device = bedData.find((bed) => bed.deviceID === data.deviceId);
			return device?.suiteName || data.suiteName || data.person || "Bilinmiyor";
		});
		setSuiteNames(names);
	}, [tableData, bedData]);

	useEffect(() => {
		const now = new Date();
		// Tüm alarm verilerini kullan (bedData filtrelemesi kaldırıldı)
		let data = tableData || [];

		if (hour.length !== 0 && hour === "last-8") {
			const eightHoursAgo = new Date(now.getTime() - 8 * 60 * 60 * 1000);
			data = data.filter((item) => new Date(item.createdAt) >= eightHoursAgo);
		} else if (hour.length !== 0 && hour === "last-week") {
			const lastWeek = new Date(
				now.getFullYear(),
				now.getMonth(),
				now.getDate() - 7
			);
			data = data.filter((item) => new Date(item.createdAt) >= lastWeek);
		} else if (hour.length !== 0 && hour === "last-month") {
			const lastMonth = new Date(
				now.getFullYear(),
				now.getMonth() - 1,
				now.getDate()
			);
			data = data.filter((item) => new Date(item.createdAt) >= lastMonth);
		}

		if (suiteName) {
			// Hem bedData'dan hem de alarm verisindeki suiteName'den filtrele
			data = data.filter((item) => {
				const device = bedData.find((bed) => bed.deviceID === item.deviceId);
				const itemSuiteName =
					device?.suiteName || item.suiteName || item.person;
				return itemSuiteName === suiteName;
			});
		}

		setFilteredAlarm(data);
	}, [hour, suiteName, tableData, bedData]);

	function convertDate(input) {
		let date;

		if (typeof input === "string" && isNaN(Number(input))) {
			date = new Date(input);
		} else {
			let timestamp = Number(input);

			if (isNaN(timestamp)) {
				return "Geçersiz zaman damgası";
			}

			if (timestamp.toString().length === 10) {
				timestamp *= 1000;
			}

			date = new Date(timestamp);
		}

		if (isNaN(date.getTime())) {
			return "Geçersiz zaman damgası";
		}

		const options = {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			hour12: false,
		};

		return date.toLocaleString("tr-TR", options);
	}

	const eventTypeMap = {
		calling: "Düşme Alarmı",
		inBed: "Yatağa Girme",
		"In Bed": "Yatağa Girme",
		outOfBed: "Yataktan Çıkma",
		"Out Of Bed": "Yataktan Çıkma",
		awayFromBed: "Yataktan Uzakta",
		bp: "Tansiyon Alarmı",
		rr: "Solunum Sayısı",
		hr: "Kalp Atış Hızı",
		bt: "Vücut Sıcaklığı Alarmı",
		callButton: "Aranma",
		fall: "Düşme Önleme Alarmı",
		falldetected: "Düşme Alarmı",
		"Low Heart Rate": "Düşük Kalp Atış Hızı",
		"High Heart Rate": "Yüksek Kalp Atış Hızı",
		"Low Respiration Rate": "Düşük Solunum Hızı",
		"High Respiration Rate": "Yüksek Solunum Hızı",
		head: "Epilepsi Alarmı",
		spo: "Oksijen Saturasyonu",
		tback: "Bası Yarası Hatırlatma",
		tleft: "Bası Yarası Hatırlatma",
		tright: "Bası Yarası Hatırlatma",
		"Posture Change": "Bası Yarası Hatırlatma",
		"Leave area": "Yataktan Çıkma",
		"Enter area": "Yatağa Girme",
		"Enter room": "Odaya Girme",
		"Leave room": "Odadan Çıkma",
		"Turn Resident": "Bası Yarası Hatırlatma",
		"Fall Prevention": "Düşme Önleme",
		// Hobacare (Viva03D) Alarmları
		"Suspected fall": "Şüpheli Düşme",
		"Fall confirmation": "Düşme Onayı",
		"No event": "Olay Yok",
		// Akıllı Saat Alarm Türleri
		sos: "SOS Alarmı",
		falldown: "Düşme Alarmı",
		removewatch: "Saat Çıkarma Alarmı",
		lowbattery: "Düşük Batarya",
		heartrate_abnormal: "Anormal Kalp Atışı",
		"Away From Bed": "Yataktan Uzakta",
	};

	return (
		<>
			<div className="table-filters">
				{/* <div className="dropdown-wrapper">
          <Form.Select onChange={(e) => setHour(e.target.value)}>
            <option>Tüm Zamanlar</option>
            <option value="last-8">Son 8 Saat</option>
            <option value="last-week">Geçen Hafta</option>
            <option value="last-month">Geçen Ay</option>
          </Form.Select>
        </div> */}
				{/* <div className="dropdown-wrapper">
          <Form.Select onChange={(e) => setSuiteName(e.target.value)}>
            <option>Süit Adı</option>
            {(() => {
              const uniqueOptions = new Set();
              return filteredAlarm
                ?.filter((data) => {
                  const device = bedData.find(
                    (device) => device.deviceID === data.deviceId
                  );
                  if (device && !uniqueOptions.has(device.suiteName)) {
                    uniqueOptions.add(device.suiteName);
                    return true;
                  }
                  return false;
                })
                .map((data, index) => {
                  const device = bedData.find(
                    (device) => device.deviceID === data.deviceId
                  );
                  return (
                    <option key={index} value={device?.suiteName}>
                      {device?.suiteName}
                    </option>
                  );
                });
            })()}
          </Form.Select>
        </div> */}
				<div className="dropdown-wrapper"></div>
			</div>
			<Table striped bordered hover responsive className="alarm-table">
				<thead>
					<tr>
						{tableTD.map((tableRow, index) => (
							<th key={index}>{tableRow}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{filteredAlarm?.map((data, index) => {
						// bedData'dan cihaz bilgisini bul
						const device = bedData.find(
							(bed) => bed.deviceID === data.deviceId
						);
						// Süit adı: önce bedData, yoksa alarm verisinden
						const suiteName =
							device?.suiteName || data.suiteName || data.person || "-";
						// Oda adı: önce bedData, yoksa alarm senaryo bilgisinden
						const roomName =
							device?.roomName ||
							(data.alarmScenario === "v46_watch" ? "Akıllı Saat" : "-");

						return (
							<tr key={index}>
								<td>{index + 1}</td>
								<td>{convertDate(data.endTimestamp)}</td>
								<td>{suiteName}</td>
								<td>
									<div className="table-icons">
										<span>{roomName}</span>
									</div>
								</td>
								<td>
									<span style={{ fontSize: 12 }}>
										{eventTypeMap[data?.eventType] || data?.eventType || "-"}
									</span>
								</td>
								<td>{data.deviceId}</td>
								<td>{data.callCount || "-"}</td>
								<td style={{ textAlign: "center" }}>
									{data.confirmation || "-"}
								</td>
								<td>{data.description || "-"}</td>
								<td style={{ fontSize: "12px" }}>
									{data.alarmScenario === "v46_watch"
										? ""
										: data.alarmScenario || "-"}
								</td>
								<td>{data.person || "-"}</td>
								<td>{data.auto === "true" ? "Otomatik Kapatma" : ""}</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</>
	);
};

export default AlarmTable;
